<div class="containers">
  <div class="klarpris-component">
    <div class="klarpris-search d-flex align-items-center">
      <div class="input-group mr-1">
        <div class="input-group-prepend align-self-center">
          <span class="input-group-text pr-1"><i class="far fa-search fa-fw"></i></span>
        </div>
        <input class="form-control align-self-center"
               type="text"
               #searchBox
               id="search-box"
               [(ngModel)]="searchValue"
               (input)="getKPproduct()"
               (keyup)="navigateResult($event)"
               autocomplete="off"
               placeholder="{{ 'Standard.SearchProduct' | translate }}">
      </div>
      <div *ngIf="clearPriceAccounts != null">
        <select class="form-control"[(ngModel)]="searchAccount" style="min-width: 9rem;" (change)="klarPrisAccountChanged(searchAccount)" title="{{ 'KlarPris.StandardAccount' | translate }}">
          <option [ngValue]="null" disabled>{{ 'KlarPris.StandardAccount' | translate }}</option>
          <option *ngFor="let x of clearPriceAccounts" [value]="x.key">{{ x.value }}</option>
        </select>
      </div>
    </div>
  </div>
  <div id="KPOutput" class="KPOutput col-12 mt-3 pl-0 pr-0" *ngIf="searchValue != ''">
    <ul class="striped-list pt-0 pl-0 mb-1" #klarPrisResults>
      <li class="font-weight-bold d-flex justify-content-center align-items-center" *ngIf="!!products && products.length == 0">{{ 'Search.NoResultsFound' | translate }}</li>
      <li *ngFor="let x of products; let i = index" [ngClass]="{'highlightedProductRow': spotProduct.row == i && spotProduct.whole == -1 }">
        <div class="productSearchLine d-flex align-items-center pl-1 pr-0">
          <div class="wholesaler-images clickable" (click)="emitCheapestProduct(x); closeResultBox()" *ngIf="!!x.image">
            <img src="{{ x.image }}" alt="{{ x.name }}" class="wholesaler-image" alt="Wholesaler image"/>
          </div>
          <div class="clickable productInfo align-items-center" (click)="emitCheapestProduct(x, x.description); closeResultBox()" [style.width]="getProductLineLength(x.wholesaler)">
            <div class="d-flex flex-column w-fit">
              <b>{{ x.number }}</b>
              <p class="productName">
                <span>{{ x.description }}</span>
              </p>
            </div>
            <div class="ml-5"><img src="{{ x.manufacturerLogo }}" class="manufacturer-image" alt="Manufacturer" *ngIf="!!x.manufacturerLogo"/></div>
          </div>
          <div class="d-flex ml-auto pl-1">
            <a *ngFor="let c of x.wholesaler; let j = index" (click)="emitChosenProduct(x,c); closeResultBox()" class="cursor-pointer pr-1 m-auto">
              <div class="badge position-relative flex-column h-100 w-100" [ngClass]="[spotProduct.row == i && spotProduct.whole == j ? 'badge-primary' : c.highLow == 1 ? 'badge-success' : c.highLow == -1 ? 'badge-danger' : c.highLow == 0 ? 'badge-secondary' : '']">
                <div class="wholesaler-text pb-1">
                  {{ c.wholesaler.value }}
                </div>
                <div class="price-text">
                  {{ c.price | number: '1.2-2' }}
                </div>
                <div class="position-absolute greenProduct" title="{{ 'ClearPrice.GreenProduct' | translate }}" (click)="emitChosenProduct(x,c); closeResultBox()" *ngIf="c.isGreen">
                  <img src="../../../assets/wholesalerIcons/wholesaler_green_1.png" alt="green certificate"/>
                </div>
              </div>
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
